"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineTestFlowClausePresent = exports.setNoGhostClauses = exports.setDisqualifyLiveFlowTargeting = exports.setGhostTargeting = undefined;
exports.getConditionsFriendlyDescription = getConditionsFriendlyDescription;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _filters = require("./filters");

var _transforms = require("./transforms");

var _utils = require("./utils");

var _constants = require("./constants");

var _languages = require("../general/languages");

var _languages2 = _interopRequireDefault(_languages);

var _utils2 = require("../steps/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setGhostTargeting = exports.setGhostTargeting = function setGhostTargeting(clauses, ghostFlowId) {
  var flattenedClauses = (0, _transforms.getFlattenedClausesFromNestedConditions)(clauses);

  var trimmedClauses = (0, _transforms.deleteMatchingClauses)(flattenedClauses, _filters.filterNonUrlTargetingClauses);

  var ghostClauses = (0, _transforms.addClause)(trimmedClauses, null, (0, _utils.testPropertyClause)(ghostFlowId));

  return (0, _transforms.getNestedConditionsFromFlattenedClauses)(ghostClauses, null, _constants.clauseKeys);
};

var setDisqualifyLiveFlowTargeting = exports.setDisqualifyLiveFlowTargeting = function setDisqualifyLiveFlowTargeting(clauses, ghostFlowId) {
  var flattenedClauses = (0, _transforms.getFlattenedClausesFromNestedConditions)(clauses);

  var diqualifyGhostClauses = (0, _transforms.addClause)(flattenedClauses, null, (0, _utils.disqualifyLiveFlowClause)(ghostFlowId));

  return (0, _transforms.getNestedConditionsFromFlattenedClauses)(diqualifyGhostClauses, null, _constants.clauseKeys);
};

var setNoGhostClauses = exports.setNoGhostClauses = function setNoGhostClauses(clauses) {
  var flattenedClauses = (0, _transforms.getFlattenedClausesFromNestedConditions)(clauses);

  var trimmedClauses = (0, _transforms.deleteMatchingClauses)(flattenedClauses, _filters.filterTestModeClauses);

  return (0, _transforms.getNestedConditionsFromFlattenedClauses)(trimmedClauses, null, _constants.clauseKeys);
};

var determineTestFlowClausePresent = exports.determineTestFlowClausePresent = function determineTestFlowClausePresent(clauses, testFlowId) {
  var flattenedClauses = (0, _transforms.getFlattenedClausesFromNestedConditions)(clauses);

  var testClausePresent = flattenedClauses.some(function (clause) {
    return (0, _filters.filterSpecificTestModeClause)(clause, testFlowId);
  });

  return testClausePresent;
};

/**
 * Converts a set of clauses (second argument) into a semi-readable english sentence.
 *
 * @param masterClause
 * @param clauses
 * @param steps
 * @param segments
 * @param shouldOmitTailPropertyNames
 * @param isFirstStatement
 * @param conjunction
 * @returns {string}
 */

function getConditionsFriendlyDescription(masterClause, clauses, steps, segments, shouldOmitTailPropertyNames) {
  var isFirstStatement = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var conjunction = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";
  var textOnly = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

  if (!clauses || !clauses.length) {
    return "No restrictions";
  }

  if (!masterClause) {
    masterClause = (0, _utils.getMasterClause)(clauses);
  }

  if (masterClause.operator === _constants.groupOperators.BOOLEAN) {
    var nuclearChildren = clauses.filter(function (_ref) {
      var parentId = _ref.parentId;
      return parentId === masterClause.id;
    });

    var baseGroupSentence = nuclearChildren.map(function (clause, c) {
      return getConditionsFriendlyDescription(clause, clauses, steps, segments, shouldOmitTailPropertyNames, c === 0, c === 0 ? conjunction : "", textOnly);
    }).join(" <span class=\"logic " + (0, _utils.htmlEncode)(masterClause.value).toLowerCase() + "\">" + (0, _utils.htmlEncode)(masterClause.value) + "</span> ");

    var groupSentence = isFirstStatement ? baseGroupSentence.replace(/(^<.{0,25}>|^)([A-Za-z])/, function (m, p1, p2) {
      return p1 + p2.toUpperCase();
    }) : baseGroupSentence;

    return " <span class=\"group\">" + groupSentence + "</span>";
  } else {
    var numDays = 0;
    var prefix = "";
    var suffix = "";
    var baseSentence = "<span class=\"condition\">";

    if ([_constants.conditionNames.URL, _constants.conditionNames.DOMAINS].includes(masterClause.conditionName)) {
      suffix = conjunction;
    } else {
      prefix = conjunction;
    }

    baseSentence += prefix;

    if (!textOnly) {
      switch (masterClause.conditionName) {
        case _constants.conditionNames.URL:
        case _constants.conditionNames.DOMAINS:
        case _constants.conditionNames.PROPERTIES:
          var omitDescriptor = shouldOmitTailPropertyNames && !isFirstStatement;
          baseSentence += omitDescriptor ? "" : "" + (shouldOmitTailPropertyNames ? "" : "property <b>") + (0, _utils.htmlEncode)((0, _utils.getPropertyDisplayName)(masterClause.property || _constants.friendlyPropertyNames[masterClause.conditionName])) + (shouldOmitTailPropertyNames ? "" : "</b>");
          var descriptor = omitDescriptor ? " " : " must " + suffix;

          switch (masterClause.operator) {
            case _constants.propertyOperators.EQUALS:
              baseSentence += descriptor + "be <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.NOT_EQUALS:
              baseSentence += descriptor + "not be <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.GREATER_THAN:
              baseSentence += descriptor + "be greater than <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.LESS_THAN:
              baseSentence += descriptor + "be less than <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.CONTAINS:
              baseSentence += descriptor + "contain <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.NOT_CONTAINS:
              baseSentence += descriptor + "not contain <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.STARTS_WITH:
              baseSentence += descriptor + "start with <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.NOT_STARTS_WITH:
              baseSentence += descriptor + "not start with <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.ENDS_WITH:
              baseSentence += descriptor + "end with <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.NOT_ENDS_WITH:
              baseSentence += descriptor + "not end with <b>" + (0, _utils.htmlEncode)(masterClause.value || "blank") + "</b>";
              break;
            case _constants.propertyOperators.EXISTS:
              baseSentence += descriptor + "exist";
              break;
            case _constants.propertyOperators.NOT_EXISTS:
              baseSentence += descriptor + "not exist";
              break;
            case _constants.propertyOperators.IN:
              baseSentence += descriptor + "be one of <b>" + masterClause.value.split("\n").length + " values</b>";
              break;
            case _constants.propertyOperators.NOT_IN:
              baseSentence += descriptor + "not be one of <b>" + masterClause.value.split("\n").length + " values</b>";
              break;
            case _constants.propertyOperators.GREATER_THAN_X_DAYS_AGO:
              numDays = masterClause.value / _constants.millisecondsPerDay;
              baseSentence += descriptor + "have occurred more than <b>" + numDays + " day" + (numDays > 1 ? "s" : "") + " ago</b>";
              break;
            case _constants.propertyOperators.LESS_THAN_X_DAYS_AGO:
              numDays = masterClause.value / _constants.millisecondsPerDay;
              baseSentence += descriptor + "have occurred less than <b>" + numDays + " day" + (numDays > 1 ? "s" : "") + " ago</b>";
              break;
            case _constants.propertyOperators.WITHIN_X_DAYS_AGO:
              numDays = masterClause.value / _constants.millisecondsPerDay;
              baseSentence += descriptor + "occur within the next <b>" + numDays + " day" + (numDays > 1 ? "s" : "") + "</b>";
              break;
            case _constants.propertyOperators.GREATER_THAN_TIME:
              baseSentence += descriptor + "have occurred after <b>" + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL") + "</b>";
              break;
            case _constants.propertyOperators.LESS_THAN_TIME:
              baseSentence += descriptor + "have occurred before <b>" + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL") + "</b>";
              break;
            case _constants.propertyOperators.REGEX:
              switch (masterClause.value) {
                case ".*":
                  baseSentence += descriptor + "match any value";
                  break;
                default:
                  baseSentence += descriptor + "match regular expression <b>" + (0, _utils.htmlEncode)(masterClause.value) + "</b>";
                  break;
              }
              break;
          }
          break;
        case _constants.conditionNames.SEGMENTS:
          var segmentName = segments && segments[masterClause.segment] ? (0, _utils.htmlEncode)(segments[masterClause.segment].name) : masterClause.segment;
          baseSentence += "user must " + (masterClause.negative ? "<b>not</b> " : "") + "belong to segment <b>" + segmentName + "</b>";
          break;
        case _constants.conditionNames.LANGUAGES:
          var language = _languages2.default.find(function (_ref2) {
            var code = _ref2.code;
            return code === masterClause.value;
          });
          baseSentence += "language must " + (masterClause.negative ? "<b>not</b> " : "") + "be <b>" + (language ? language.desc : (0, _utils.htmlEncode)(masterClause.value)) + "</b>";
          break;
        case _constants.conditionNames.CONTENT:
          var flowName = (0, _utils.htmlEncode)((0, _utils2.getStepLabel)(masterClause.content, steps));
          var step = steps[masterClause.content];
          var completionEventLabel = (0, _utils2.getStepCompletionEventLabel)(step);
          baseSentence += "flow <b>" + flowName + "</b> must " + (masterClause.negative ? "<b>not</b> " : "") + "have been " + completionEventLabel;
          if (masterClause.times) {
            baseSentence += " at least " + masterClause.times + " time" + (masterClause.times > 1 ? "s" : "");
          }
          if (masterClause.operator === _constants.propertyOperators.SINCE && masterClause.value > 0) {
            baseSentence += " since " + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL");
          } else if (masterClause.operator === _constants.propertyOperators.LESS_THAN_X_DAYS_AGO) {
            var _numDays = masterClause.value / _constants.millisecondsPerDay;
            baseSentence += " in the last " + _numDays + " day" + (_numDays > 1 ? "s" : "");
          }
          break;
        case _constants.conditionNames.EVENT:
          baseSentence += "event <b>" + (0, _utils.htmlEncode)(masterClause.event) + "</b> must " + (masterClause.negative ? "<b>not</b> " : "") + "have occurred";
          if (masterClause.times) {
            baseSentence += " at least " + masterClause.times + " time" + (masterClause.times > 1 ? "s" : "");
          }
          if (masterClause.operator === _constants.propertyOperators.SINCE && masterClause.value > 0) {
            baseSentence += " since " + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL");
          } else if (masterClause.operator === _constants.propertyOperators.LESS_THAN_X_DAYS_AGO) {
            var _numDays2 = masterClause.value / _constants.millisecondsPerDay;
            baseSentence += " in the last " + _numDays2 + " day" + (_numDays2 > 1 ? "s" : "");
          }
          break;
        case _constants.conditionNames.FREQUENCY:
          baseSentence += "users will " + (masterClause.frequency === "never" ? "not " : "") + " see this flow ";
          if (masterClause.frequency === "once") {
            baseSentence += "once";
          } else if (masterClause.frequency === "every_time") {
            baseSentence += "every time they match all of the other criteria";
          } else if (masterClause.frequency === "never") {
            baseSentence += "until it is manually triggered";
          }
          break;
      }
    } else {
      switch (masterClause.conditionName) {
        case _constants.conditionNames.URL:
        case _constants.conditionNames.DOMAINS:
        case _constants.conditionNames.PROPERTIES:
          var _omitDescriptor = shouldOmitTailPropertyNames && !isFirstStatement;
          baseSentence += _omitDescriptor ? "" : "" + (shouldOmitTailPropertyNames ? "" : "property ") + (0, _utils.htmlEncode)((0, _utils.getPropertyDisplayName)(masterClause.property || _constants.friendlyPropertyNames[masterClause.conditionName]));
          var _descriptor = _omitDescriptor ? "" : " must " + suffix;

          switch (masterClause.operator) {
            case _constants.propertyOperators.EQUALS:
              baseSentence += _descriptor + "be " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.NOT_EQUALS:
              baseSentence += _descriptor + "not be " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.GREATER_THAN:
              baseSentence += _descriptor + "be greater than " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.LESS_THAN:
              baseSentence += _descriptor + "be less than " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.CONTAINS:
              baseSentence += _descriptor + "contain " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.NOT_CONTAINS:
              baseSentence += _descriptor + "not contain " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.STARTS_WITH:
              baseSentence += _descriptor + "start with " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.NOT_STARTS_WITH:
              baseSentence += _descriptor + "not start with " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.ENDS_WITH:
              baseSentence += _descriptor + "end with " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.NOT_ENDS_WITH:
              baseSentence += _descriptor + "not end with " + (0, _utils.htmlEncode)('"' + masterClause.value + '"' || "blank");
              break;
            case _constants.propertyOperators.EXISTS:
              baseSentence += _descriptor + "exist";
              break;
            case _constants.propertyOperators.NOT_EXISTS:
              baseSentence += _descriptor + "not exist";
              break;
            case _constants.propertyOperators.IN:
              baseSentence += _descriptor + "be one of " + masterClause.value.split("\n").length + " values";
              break;
            case _constants.propertyOperators.NOT_IN:
              baseSentence += _descriptor + "not be one of " + masterClause.value.split("\n").length + " values";
              break;
            case _constants.propertyOperators.GREATER_THAN_X_DAYS_AGO:
              numDays = masterClause.value / _constants.millisecondsPerDay;
              baseSentence += _descriptor + "have occurred more than " + numDays + " day" + (numDays > 1 ? "s" : "") + " ago";
              break;
            case _constants.propertyOperators.LESS_THAN_X_DAYS_AGO:
              numDays = masterClause.value / _constants.millisecondsPerDay;
              baseSentence += _descriptor + "have occurred less than " + numDays + " day" + (numDays > 1 ? "s" : "") + " ago";
              break;
            case _constants.propertyOperators.WITHIN_X_DAYS_AGO:
              numDays = masterClause.value / _constants.millisecondsPerDay;
              baseSentence += _descriptor + "occur within the next " + numDays + " day" + (numDays > 1 ? "s" : "");
              break;
            case _constants.propertyOperators.GREATER_THAN_TIME:
              baseSentence += _descriptor + "have occurred after " + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL");
              break;
            case _constants.propertyOperators.LESS_THAN_TIME:
              baseSentence += _descriptor + "have occurred before " + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL");
              break;
            case _constants.propertyOperators.REGEX:
              switch (masterClause.value) {
                case ".*":
                  baseSentence += _descriptor + "match any value";
                  break;
                default:
                  baseSentence += _descriptor + "match regular expression \"" + (0, _utils.htmlEncode)(masterClause.value) + "\"";
                  break;
              }
              break;
          }
          break;
        case _constants.conditionNames.SEGMENTS:
          var _segmentName = segments && segments[masterClause.segment] ? (0, _utils.htmlEncode)(segments[masterClause.segment].name) : masterClause.segment;
          baseSentence += "user must " + (masterClause.negative ? "not " : "") + "belong to segment \"" + _segmentName + "\"";
          break;
        case _constants.conditionNames.LANGUAGES:
          var _language = _languages2.default.find(function (_ref3) {
            var code = _ref3.code;
            return code === masterClause.value;
          });
          baseSentence += "language must " + (masterClause.negative ? "not " : "") + "be <b>" + (_language ? _language.desc : (0, _utils.htmlEncode)(masterClause.value)) + "</b>";
          break;
        case _constants.conditionNames.CONTENT:
          var _flowName = (0, _utils.htmlEncode)((0, _utils2.getStepLabel)(masterClause.content, steps));
          var _step = steps[masterClause.content];
          var _completionEventLabel = (0, _utils2.getStepCompletionEventLabel)(_step);
          baseSentence += "flow \"" + _flowName + "\" must " + (masterClause.negative ? "not " : "") + "have been " + _completionEventLabel;
          if (masterClause.times) {
            baseSentence += " at least " + masterClause.times + " time" + (masterClause.times > 1 ? "s" : "");
          }
          if (masterClause.operator === _constants.propertyOperators.SINCE && masterClause.value > 0) {
            baseSentence += " since " + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL");
          } else if (masterClause.operator === _constants.propertyOperators.LESS_THAN_X_DAYS_AGO) {
            var _numDays3 = masterClause.value / _constants.millisecondsPerDay;
            baseSentence += " in the last " + _numDays3 + " day" + (_numDays3 > 1 ? "s" : "");
          }
          break;
        case _constants.conditionNames.EVENT:
          baseSentence += "event \"" + (0, _utils.htmlEncode)(masterClause.event) + "\" must " + (masterClause.negative ? "not " : "") + "have occurred";
          if (masterClause.times) {
            baseSentence += " at least " + masterClause.times + " time" + (masterClause.times > 1 ? "s" : "");
          }
          if (masterClause.operator === _constants.propertyOperators.SINCE && masterClause.value > 0) {
            baseSentence += " since " + (0, _moment2.default)(parseInt(masterClause.value, 10)).format("LL");
          } else if (masterClause.operator === _constants.propertyOperators.LESS_THAN_X_DAYS_AGO) {
            var _numDays4 = masterClause.value / _constants.millisecondsPerDay;
            baseSentence += " in the last " + _numDays4 + " day" + (_numDays4 > 1 ? "s" : "");
          }
          break;
        case _constants.conditionNames.FREQUENCY:
          baseSentence += "users will " + (masterClause.frequency === "never" ? "not " : "") + " see this flow ";
          if (masterClause.frequency === "once") {
            baseSentence += "once";
          } else if (masterClause.frequency === "every_time") {
            baseSentence += "every time they match all of the other criteria";
          } else if (masterClause.frequency === "never") {
            baseSentence += "until it is manually triggered";
          }
          break;
      }
    }
    baseSentence += "</span>";
    return baseSentence;
  }
}